import { getSiteMap } from '@gik/api/legal';
import type { FallbackProps, StaticProps } from '@gik/core/api/BaseAPIConfig';
import { ISRRevalidateTimeout, baseFallback } from '@gik/core/api/BaseAPIConfig';
import { PageHeadKeys } from '@gik/core/hocs/PageHeadKeys';
import { withTitle } from '@gik/core/hocs/withTitle';
import { ArticlesSitemapPage } from '@gik/core/pages/ArticlesSitemap';
import { catchSSRError } from '@gik/core/utils/catchSSRError';
import { measureSSRPerformance } from '@gik/core/utils/measureSSRPerformance';
import Head from '@/components/Head';
import { SWRConfig } from 'swr';

export default function ArticlesSitemapPageComp({ fallback }: FallbackProps<unknown>) {
  return withTitle(
    'Articles Sitemap',
    <SWRConfig value={{ fallback }}>
      <Head>
        <meta name="robots" key={PageHeadKeys.META_ROBOTS} content="index,follow" />
      </Head>
      <ArticlesSitemapPage />
    </SWRConfig>
  );
}

async function _getStaticProps(): Promise<StaticProps<string[]>> {
  const sitePages = getSiteMap();

  const json = await sitePages.json;

  return baseFallback({ [sitePages.key]: json }, undefined, ISRRevalidateTimeout.sitemapSlow);
}

export const getStaticProps = catchSSRError(measureSSRPerformance(_getStaticProps));
